const ALIASES = {
  'tottenham': 'Tottenham Hotspur',
  'tottenham hotspur': 'Tottenham Hotspur',
  'man utd': 'Manchester United',
  'man united': 'Manchester United',
  'manchester united': 'Manchester United',
  'brondby': 'Brøndby',
  'brøndby': 'Brøndby',
  'newcaste': 'Newcastle',
  'newcastle': 'Newcastle',
  'bolivia': 'Bólivía',
  'bólivía': 'Bólivía',
};
export const teamDisplay = (name) => ALIASES[String(name || '').trim().toLocaleLowerCase('is-IS')] || name;
export const teamSlug = (name) => String(teamDisplay(name) || '').trim().toLocaleLowerCase('is-IS').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ð/g, 'd').replace(/þ/g, 'th').replace(/æ/g, 'ae').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
export const teamMatches = (product, slug) => teamSlug(product?.team) === slug || (slug === 'tottenham' && teamSlug(product?.team) === 'tottenham-hotspur');
